<template>
  <div class="countdown">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <div class="countdown-title">
            Обратный отсчет до повышения цен 🚀
          </div>
          <div class="countdown-wrap">
            <template v-if="timeLeft">
              <div class="countdown-item">
                <div class="time">{{ timeLeft.days }}</div>
                <div class="desc">дней</div>
              </div>
              <div class="countdown-item">
                <div class="time">{{ timeLeft.hours }}</div>
                <div class="desc">часов</div>
              </div>
              <div class="countdown-item">
                <div class="time">{{ timeLeft.minutes }}</div>
                <div class="desc">минут</div>
              </div>
              <div class="countdown-item">
                <div class="time">{{ timeLeft.seconds }}</div>
                <div class="desc">секунд</div>
              </div>
            </template>
            <template v-else>
              <div class="countdown-item">
                <div class="time">0</div>
                <div class="desc">дней</div>
              </div>
              <div class="countdown-item">
                <div class="time">0</div>
                <div class="desc">часов</div>
              </div>
              <div class="countdown-item">
                <div class="time">0</div>
                <div class="desc">минут</div>
              </div>
              <div class="countdown-item">
                <div class="time">0</div>
                <div class="desc">секунд</div>
              </div>
            </template>
          </div>
          <div class="countdown-info">
            Успей купить билет<br class="d-inline d-md-none">
            по самой выгодной цене<br>
            <small>
              до 15 февраля | 23:59 Мск
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, onBeforeUnmount, reactive} from 'vue';

export default {
  name: "Timer",
  setup() {
    const timeLeft = reactive({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    let intervalId = null;

    const calculateCountdown = () => {
      const targetDate = new Date('February 16, 2024 23:59:00 GMT+0300'); // Дата
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        clearInterval(intervalId);
        intervalId = null;
        return;
      }

      timeLeft.days = Math.floor(difference / (1000 * 60 * 60 * 24));
      timeLeft.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      timeLeft.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      timeLeft.seconds = Math.floor((difference % (1000 * 60)) / 1000);
    };

    onMounted(() => {
      calculateCountdown();
      intervalId = setInterval(calculateCountdown, 1000);
    });

    onBeforeUnmount(() => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    });

    return {timeLeft};
  }
}
</script>

<style lang="scss" scoped>
.countdown {
  margin-top: 60px;
  @include _768 {
    margin-top: 120px;
  }
}

.countdown-title {
  color: var(--white, #FFF);
  text-align: center;
  font-family: Play, serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 138%; /* 35.88px */
  margin-bottom: 20px;
}

.countdown-info {
  color: var(--white, #FFF);
  text-align: center;
  font-family: Play, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 112%; /* 20.16px */
  margin-top: 20px;
  @include _768 {
    font-size: 26px;
  }

  small {
    color: var(--inputs-gray, #6B7380);
    text-align: center;
    font-family: Museo Sans Cyrl, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 128%; /* 20.48px */
    margin-top: 10px;
    display: block;
  }
}

.countdown-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid var(--all-Deep-dark, #3D3F59);
  padding: 18px 30px;
  @include _768 {
    border-radius: 266px;
  }

  .countdown-item {
    position: relative;
    display: flex;
    flex-direction: column;
    width: calc(100% / 4);

    &:not(:last-child) {
      &:after {
        content: '';
        width: 4px;
        height: 10px;
        background: url(~@/assets/time-split.svg) no-repeat center;
        background-size: cover;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        @include _768 {
          height: 18px;
        }
      }
    }

    .time {
      color: #7BB8FF;
      text-align: center;
      font-family: Play, serif;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 128%; /* 35.84px */
      @include _768 {
        font-size: 56px;
        line-height: 108%;
      }
    }

    .desc {
      color: #7BB8FF;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 146%; /* 20.44px */
      @include _768 {
        font-size: 16px;
        line-height: 128%;
      }
    }
  }
}
</style>